"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateParents = exports.updateChildren = exports.getNodesCoDependent = exports.flatten = exports.default = exports.createTree = exports.convertSelectedNodes = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _lodash = _interopRequireDefault(require("lodash"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var flatten = function flatten(tree) {
  var array = Array.isArray(tree) ? tree : [tree];
  return array.reduce(function (acc, value) {
    acc.push(value);
    if (value.children) {
      // eslint-disable-next-line no-param-reassign
      acc = acc.concat(flatten(value.children));
    }
    return acc;
  }, []);
};
exports.flatten = flatten;
var createTree = function createTree(list) {
  var hashTable = {};
  var tree = [];
  var buildAncestors = function buildAncestors(node) {
    return node.parentNodeId ? node.nodePath.split('|').forEach(function (n) {
      return hashTable[n] && node.ancestors.push(hashTable[n]);
    }) : null;
  };
  list.forEach(function (node) {
    return hashTable[node.nodeId] = _objectSpread(_objectSpread({}, node), {}, {
      children: [],
      checked: false,
      disabled: false,
      ancestors: []
    });
  });
  list.forEach(function (node) {
    return node.parentNodeId && hashTable[node.parentNodeId] ? hashTable[node.parentNodeId].children.push(hashTable[node.nodeId]) && buildAncestors(hashTable[node.nodeId]) : tree.push(hashTable[node.nodeId]);
  });
  return tree;
};
exports.createTree = createTree;
var updateParents = function updateParents(node, currentNode, checkedValue) {
  if (!node) {
    return;
  }
  for (var i = 0; i < node.length; i += 1) {
    var child = node[i];
    if (currentNode.nodePath.includes(child.nodeId)) {
      child.checked = checkedValue;
    }
    if (child.children.length) {
      updateParents(child.children, currentNode, checkedValue);
    }
  }
};
exports.updateParents = updateParents;
var updateChildren = function updateChildren(node, checkedValue) {
  if (!node) {
    return;
  }
  // eslint-disable-next-line no-param-reassign
  node.checked = checkedValue;
  if (node.children.length) {
    node.children.forEach(function (child) {
      return updateChildren(child, checkedValue);
    });
  }
};

/**
 * Get node list  Co-Dependent in the tree
 * @param {Array}  levels         total level in tree
 * @param {Object} selectedLevel  The level is selected
 * @param {Array}  nodeList       Total nodes in tree
 * @param {Array}  tree           The tree that you want to get the node list co-dêpndent
 * @param {array} [initNodes=[]]  The init selected node
 * @return {Array}                The node list result
 */
exports.updateChildren = updateChildren;
var getNodesCoDependent = function getNodesCoDependent(levels, selectedLevel, nodeList, tree) {
  var initNodes = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  if (!tree) {
    return initNodes;
  }
  var getAllLevelNodes = function getAllLevelNodes(nodeLevel) {
    return nodeList.filter(function (node) {
      return node.levelIndex === levels[nodeLevel].levelIndex;
    });
  };
  // show root level and checked nodes
  var isNodeCheckedInRootLevel = function isNodeCheckedInRootLevel(node) {
    return node.levelIndex === levels[0].levelIndex || node.checked;
  };

  // if parent is checked, only show its children
  var hasNodeParentChecked = function hasNodeParentChecked(node) {
    return node.ancestors.length > 0 && node.ancestors[node.ancestors.length - 2].checked;
  };
  // if root node is checked and no parents are checked,
  // show all children of the root
  var isNodeCheckedWithNoParentChecked = function isNodeCheckedWithNoParentChecked(node) {
    return node.ancestors.length > 0 && node.ancestors[0].checked && getAllLevelNodes(0).filter(function (n) {
      return n.checked;
    }).includes(node.ancestors[0]) && getAllLevelNodes(node.levelIndex - 1).every(function (n) {
      return !n.checked;
    });
  };
  var resultList = initNodes;
  for (var i = 0; i < tree.length; i += 1) {
    var node = tree[i];
    if (initNodes.includes(node)) {
      return initNodes;
    }
    if (node.levelId === selectedLevel && (isNodeCheckedInRootLevel(node) || isNodeCheckedWithNoParentChecked(node) || hasNodeParentChecked(node))) {
      resultList = _lodash.default.concat(resultList, node);
    }
    if (node.children) {
      resultList = getNodesCoDependent(levels, selectedLevel, nodeList, node.children, resultList);
    }
  }
  return resultList;
};

/**
 * Convert node ids to node list
 * @param {*} nodeIds
 * @param {*} nodeList
 * @returns mapped result
 */
exports.getNodesCoDependent = getNodesCoDependent;
var convertSelectedNodes = function convertSelectedNodes(nodeIds, nodeList) {
  if (_lodash.default.isEmpty(nodeIds) || _lodash.default.isEmpty(nodeList)) {
    return [];
  }
  return nodeList.filter(function (n) {
    return _lodash.default.includes(nodeIds, n.id);
  }).map(function (n) {
    return _objectSpread(_objectSpread({}, n), {}, {
      // mark the node is selected
      checked: true
    });
  });
};
exports.convertSelectedNodes = convertSelectedNodes;
var _default = {
  createTree: createTree,
  flatten: flatten,
  updateParents: updateParents,
  updateChildren: updateChildren,
  getNodesCoDependent: getNodesCoDependent,
  convertSelectedNodes: convertSelectedNodes
};
exports.default = _default;